import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';

const shadowAction = createDefaultActionDefinition(
  StylesDerivedNativeActions.shadowStyles,
);

export default shadowAction;
